import React, { useContext, useEffect, useState } from 'react';
import {IsLoggedContext} from '../Store'
import {Link} from 'react-router-dom'
import '../styles/home.css'
import '../styles/global.css'
import { config } from '../server'
import { useAuth0 } from '@auth0/auth0-react';
const address = config.url.API_URL

const Home = () => {
	
const [isLogged] = useContext(IsLoggedContext)
const [usernames, setUsernames] = useState([])
const [name, setName] = useState('')
const { user, isAuthenticated, isLoading } = useAuth0();

useEffect(() => {

	const getName = async () => {
		const response = await fetch(address + `/api/${user.email}/getUser`)
		const data1 = await response.json()
		setName(data1.name)
	}
	getName()

	fetch(address + '/api/getSets').then(res => res.json()).then(data => {
	// console.log(data)
	const data2 = data.allDocs

	let studySetInfo = []
	for(let i = 0; i < data.allDocs.length; i++) {
		if(data2[i].name !== isLogged || data2[i].name === isLogged){
		studySetInfo.push({studyTitle: data2[i].studyTitle, names: data2[i].name})
		}
	}
	const filteredArr = studySetInfo.reduce((acc, current) => {
	const x = acc.find(item => item.studyTitle=== current.studyTitle);
	if (!x) {
		return acc.concat([current]);
	} else {
		return acc;
	}
	}, []);
	setUsernames(filteredArr.reverse())
	});
}, [isLogged, user.email]);

if (isLoading) {
    return <div>Loading ...</div>;
  }

return(
	    isAuthenticated && (
       <section className="">
		<div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-item">
						{name.length < 1 && <h1 className="title">
							Hey {user.nickname}! Welcome to Clusterfy.
						</h1>}
						
						{name.length > 1 && <h1 className="title">Hey {name}! Welcome to Clusterfy.</h1>}
					</div>
					<div className="level-item">
						<h2 className="subtitle">
							We strive to provide the tools you need to be successful in the classroom.
						</h2>
					</div>
				</div>
			</div>
		</div>

		<div className="infoContainer">
			<div className="infoCol">
				<img alt="" src="home.svg"></img>
			</div>
			<div className="infoCol">
				<div className="infoColText">
					<h2>Achieve your greatest potential.</h2>
					<p>
						At Clusterfy, we provide the tools to help you ace your classes. From enhanced study sets to on-demand online tutoring, we know a thing or two about making learning more accessible.
					</p>
					<div className="centerSingleLine">
						<a href="#explore" className="tealBtn centerBtn">See How</a>
					</div>
				</div>
			</div>
		</div>


		<div className="recentSetsContainer" id="explore">
			<h2 className="blueTitle">Recent Sets</h2>
			{
				usernames.slice(0, 10).map((studyInfo, i) => (
					<Link key={i} className="setCard" to={{pathname: `${studyInfo.studyTitle}`}}>
						<header key={i+1}>
							<div className="setCardTitle">
								{studyInfo.studyTitle}
							</div>
							<div key={i} className="setCardAuthor">
								<p key={i+2} className="">Created By {studyInfo.names}</p>
							</div>
						</header>
					</Link>
				))
			}
			<div className="centerSingleLine topMargin">
				<Link to="/explore" className="blueBtn">Explore All</Link>
			</div>
		</div>

	</section>
) 

)};

export default Home;